import user from './user'
import account from './account'
import addresses from './addresses'
import listings from './listings'
import surveys from './surveys'
import invite from './invite'
import surveyListings from './surveyListings'
import buildings from './buildings'
import magicLinkTokens from './magicLinkTokens'
import imports from './imports'

export default {
  ...user,
  ...account,
  ...addresses,
  ...listings,
  ...surveys,
  ...invite,
  ...surveyListings,
  ...buildings,
  ...magicLinkTokens,
  ...imports,
}
